export default function Backdrop() {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          background: [`rgb(255 255 255 / 30%)`],
          backdropFilter: `blur(6px)`,
          "&.MuiBackdrop-invisible": {
            background: "transparent",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          "&.MuiPaper-root": {
            borderRadius: "24px",
          },
        },
      },
    },
  };
}
